import { NavLink } from 'react-router-dom'
import { Lock } from 'lucide-react'
import { useAuthority } from '@/hooks/useAuthority'

/**
 * Abas da área interna do catálogo de propostas. Quem monta proposta
 * (inclusive representante) não chega aqui: vê só as linhas prontas no
 * assistente, sem preço cheio, peso ou versão de tabela.
 */
export function ProposalCatalogNav() {
  const { can } = useAuthority()
  const tabs = [
    { to: '/settings/commercial/proposal-catalog', label: 'Linhas e coberturas', perm: 'settings.proposal_setup.view' },
    { to: '/settings/commercial/proposal-pricing', label: 'Tabelas de preço', perm: 'settings.proposal_pricing.view' },
    { to: '/settings/commercial/proposal-setup', label: 'Cadastros', perm: 'settings.proposal_setup.view' },
  ].filter(t => can(t.perm))

  return (
    <div className="mb-5 flex flex-wrap items-center justify-between gap-3 border-b border-gray-200">
      <nav aria-label="Catálogo de propostas" className="-mb-px flex gap-1 overflow-x-auto">
        {tabs.map(t => (
          <NavLink key={t.to} to={t.to} end
            className={({ isActive }) => `whitespace-nowrap border-b-2 px-3 py-2.5 text-sm transition ${isActive
              ? 'border-brand-500 font-semibold text-brand-700'
              : 'border-transparent text-gray-600 hover:text-gray-900'}`}>
            {t.label}
          </NavLink>
        ))}
      </nav>
      <span className="mb-2 inline-flex items-center gap-1.5 rounded-full bg-gray-100 px-2.5 py-1 text-xs text-gray-600">
        <Lock size={12} /> Área interna · representantes não veem
      </span>
    </div>
  )
}
